import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class ColorPickerController implements angular.IComponentController {
    isLoading: boolean;
    static $inject = [];
}

export const wtColorPicker: ComponentDefinition = {
    componentId: 'wtColorPicker',
    controller: ColorPickerController,
    controllerAs: 'vm',
    template: require('./colorPicker.component.html'),
    bindings: {
        position: '<?',
        model: '=',
        small: '<?',
        disabled: '<?'
    }
};
